import { WorkgroupUserListListBladeType } from './list/workgroupUsersListContainer';
import { EditUserBladeType } from '../createUser';

export const BladeTypes = {
  WorkgroupUserListListBladeType,
  EditUserBladeType
};
